import { DashboardElementType } from "~/enums/dashboards/dashboardElementType";
import { StringHelper } from "~/helpers/stringHelper";
import assertNever from "../../../../global/assetNever";


export default class DashboardElementDefinition {
  static getConfigurationComponent(contentType: DashboardElementType): string {
    return `configure-${DashboardElementDefinition.getComponent(contentType)}`
  }

  static getComponent(contentType: DashboardElementType): string {
    switch (contentType) {
      case DashboardElementType.Heading:
        return 'dashboard-element-heading'
      case DashboardElementType.Subheading:
        return 'dashboard-element-heading';
      case DashboardElementType.Grid:
        return 'dashboard-element-grid';
      case DashboardElementType.Analytic:
        return 'dashboard-element-analytic';
      case DashboardElementType.MyActions:
        return 'dashboard-element-my-actions';
      case DashboardElementType.ListView:
        return 'dashboard-element-list-view';
      default:
        assertNever(contentType);
    }
  }

  static getDisplayName(contentType: DashboardElementType): string {
    switch (contentType) {
      case DashboardElementType.Heading:
        return 'Heading';
      case DashboardElementType.Subheading:
        return 'Sub Heading';
      case DashboardElementType.Grid:
        return 'Grid';
      case DashboardElementType.Analytic:
        return 'Analytic';
      case DashboardElementType.MyActions:
        return 'My Actions';
      case DashboardElementType.ListView:
        return 'List View';
      default:
        assertNever(contentType);
    }
  }

  static getIcon(contentType: DashboardElementType): string {
    switch (contentType) {
      case DashboardElementType.Heading:
        return 'heading icon'
      case DashboardElementType.Subheading:
        return 'subheading icon';
      case DashboardElementType.Grid:
        return 'grid icon';
      case DashboardElementType.Analytic:
        return 'analytic icon';
      case DashboardElementType.MyActions:
        return 'list-view icon';
      case DashboardElementType.ListView:
        return 'action-menu icon';
      default:
        assertNever(contentType);
    }
  }


  static getCssClassName(contentType: DashboardElementType): string {
    switch (contentType) {
      default:
        return  DashboardElementDefinition.getDisplayName(contentType)
    }
  }

  static getComponentClass(contentType: DashboardElementType): string {
    return `builder-element element-${StringHelper.toDash(DashboardElementDefinition.getCssClassName(contentType))} dashboard-element-${StringHelper.toDash(DashboardElementDefinition.getCssClassName(contentType))}`;
  }

  static getControlGroups(): { name: string, icon: string, type: DashboardElementType }[] {
    return [
      {
        name: DashboardElementDefinition.getDisplayName(DashboardElementType.Grid),
        icon: DashboardElementDefinition.getIcon(DashboardElementType.Grid),
        type: DashboardElementType.Grid,
      },
      {
        name: DashboardElementDefinition.getDisplayName(DashboardElementType.Heading),
        icon: DashboardElementDefinition.getIcon(DashboardElementType.Heading),
        type: DashboardElementType.Heading,
      },
      {
        name: DashboardElementDefinition.getDisplayName(DashboardElementType.Subheading),
        icon: DashboardElementDefinition.getIcon(DashboardElementType.Subheading),
        type: DashboardElementType.Subheading,
      },
      {
        name: DashboardElementDefinition.getDisplayName(DashboardElementType.Analytic),
        icon: DashboardElementDefinition.getIcon(DashboardElementType.Analytic),
        type: DashboardElementType.Analytic,
      },
      {
        name: DashboardElementDefinition.getDisplayName(DashboardElementType.MyActions),
        icon: DashboardElementDefinition.getIcon(DashboardElementType.MyActions),
        type: DashboardElementType.MyActions,
      },
      {
        name: DashboardElementDefinition.getDisplayName(DashboardElementType.ListView),
        icon: DashboardElementDefinition.getIcon(DashboardElementType.ListView),
        type: DashboardElementType.ListView,
      },
    ];
  }

}